/**
 * Replaces null or undefined values with empty strings in arrays that contain string elements.
 * This is necessary to ensure that string arrays do not contain null or undefined values, so every value
 * keeps its proper place when processed and stored, especially important for arrays that are translated
 * where the order or the translations and ensuring translations match the original array is crucial.
 * The empty strings act as spaces or placeholders.
 */

export function replaceEmptyValuesInStringArray(data: any): any {
  // For arrays: check if this is a string array, then process accordingly
  if (Array.isArray(data)) {
    const hasStringElements = data.some((item) => typeof item === 'string');

    // Process the array based on whether it contains strings
    return data.map((item) => {
      // If it's a null or undefined in a string array, replace with empty string
      if (hasStringElements && (item === null || item === undefined)) {
        return '';
      }

      // For non-string arrays or non-null/undefined values in string arrays,
      // process nested objects/arrays recursively
      if (typeof item === 'object' && item !== null) {
        return replaceEmptyValuesInStringArray(item);
      }

      // Return primitive values as is
      return item;
    });
  }

  // Handle objects: recursively process properties to find nested arrays
  if (typeof data === 'object' && data !== null) {
    const result = { ...data };
    Object.keys(result).forEach((key) => {
      result[key] = replaceEmptyValuesInStringArray(result[key]);
    });
    return result;
  }

  // Return everything else unchanged (including null when not in a string array)
  return data;
}
